import axios from 'axios';

export const authApi = axios.create({
    baseURL: 'https://backgonavi.gabocrm.com/',
    
})
